// src/api/salles.js
import { CONFIG } from '../config/config';

function authHeaders() {
  const token = localStorage.getItem('token') || sessionStorage.getItem('token');
  return {
    'Content-Type': 'application/json',
    Authorization: token ? `Bearer ${token}` : '',
  };
}

export async function listEntites() {
  const r = await fetch(`${CONFIG.API_URL}/salles/entites`, { headers: authHeaders() });
  if (!r.ok) throw new Error(`HTTP ${r.status}`);
  return await r.json();
}

export async function createEntite(payload) {
  const r = await fetch(`${CONFIG.API_URL}/salles/entites`, {
    method: 'POST',
    headers: authHeaders(),
    body: JSON.stringify(payload),
  });
  const data = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(data.message || `HTTP ${r.status}`);
  return data;
}

export async function updateEntite(id, payload) {
  const r = await fetch(`${CONFIG.API_URL}/salles/entites/${id}`, {
    method: 'PATCH',
    headers: authHeaders(),
    body: JSON.stringify(payload),
  });
  const data = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(data.message || `HTTP ${r.status}`);
  return data;
}

export async function deleteEntite(id) {
  const r = await fetch(`${CONFIG.API_URL}/salles/entites/${id}`, {
    method: 'DELETE',
    headers: authHeaders(),
  });
  const data = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(data.message || `HTTP ${r.status}`);
  return data;
}

export async function createEtablissement(payload) {
  const r = await fetch(`${CONFIG.API_URL}/salles/etablissements`, {
    method: 'POST',
    headers: authHeaders(),
    body: JSON.stringify(payload),
  });
  const data = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(data.message || `HTTP ${r.status}`);
  return data;
}

export async function updateEtablissement(id, payload) {
  const r = await fetch(`${CONFIG.API_URL}/salles/etablissements/${id}`, {
    method: 'PATCH',
    headers: authHeaders(),
    body: JSON.stringify(payload),
  });
  const data = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(data.message || `HTTP ${r.status}`);
  return data;
}

export async function listSalles() {
  const r = await fetch(`${CONFIG.API_URL}/salles`, { headers: authHeaders() });
  if (!r.ok) throw new Error(`HTTP ${r.status}`);
  return await r.json();
}
export async function createSalle(payload) {
  const r = await fetch(`${CONFIG.API_URL}/salles`, {
    method: 'POST',
    headers: authHeaders(),
    body: JSON.stringify(payload),
  });
  const data = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(data.message || `HTTP ${r.status}`);
  return data;
}

export async function updateSalle(id, payload) {
  const r = await fetch(`${CONFIG.API_URL}/salles/${id}`, {
    method: 'PATCH',
    headers: authHeaders(),
    body: JSON.stringify(payload),
  });
  const data = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(data.message || `HTTP ${r.status}`);
  return data;
}

export async function listGroups() {
  const r = await fetch(`${CONFIG.API_URL}/salles/groups`, { headers: authHeaders() });
  if (!r.ok) throw new Error(`HTTP ${r.status}`);
  return await r.json();
}

export async function createGroup(payload) {
  const r = await fetch(`${CONFIG.API_URL}/salles/groups`, {
    method: 'POST',
    headers: authHeaders(),
    body: JSON.stringify(payload),
  });
  const data = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(data.message || `HTTP ${r.status}`);
  return data;
}

export async function updateGroup(id, payload) {
  const r = await fetch(`${CONFIG.API_URL}/salles/groups/${id}`, {
    method: 'PATCH',
    headers: authHeaders(),
    body: JSON.stringify(payload),
  });
  const data = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(data.message || `HTTP ${r.status}`);
  return data;
}

export async function deleteGroup(id) {
  const r = await fetch(`${CONFIG.API_URL}/salles/groups/${id}`, {
    method: 'DELETE',
    headers: authHeaders(),
  });
  const data = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(data.message || `HTTP ${r.status}`);
  return data;
}

export async function addSalleToGroup(id, payload) {
  const r = await fetch(`${CONFIG.API_URL}/salles/groupSalles/${id}`, {
    method: 'PATCH',
    headers: authHeaders(),
    body: JSON.stringify(payload),
  });
  const data = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(data.message || `HTTP ${r.status}`);
  return data;
}

export async function listTypesSalles() {
  const r = await fetch(`${CONFIG.API_URL}/salles/types`, { headers: authHeaders() });
  if (!r.ok) throw new Error(`HTTP ${r.status}`);
  return await r.json();
}

export async function createTypeSalle(payload) {
  const r = await fetch(`${CONFIG.API_URL}/salles/types`, {
    method: 'POST',
    headers: authHeaders(),
    body: JSON.stringify(payload),
  });
  const data = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(data.message || `HTTP ${r.status}`);
  return data;
}

export async function updateTypeSalle(id, payload) {
  const r = await fetch(`${CONFIG.API_URL}/salles/types/${id}`, {
    method: 'PATCH',
    headers: authHeaders(),
    body: JSON.stringify(payload),
  });
  const data = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(data.message || `HTTP ${r.status}`);
  return data;
}

export async function deleteTypeSalle(id) {
  const r = await fetch(`${CONFIG.API_URL}/salles/types/${id}`, {
    method: 'DELETE',
    headers: authHeaders(),
  });
  const data = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(data.message || `HTTP ${r.status}`);
  return data;
}